module.exports = "<div> <div class=\"row\"> <div class=\"col-md-4\"> <span class=\"img-fluid img-rounded\"></span> </div> <div class=\"col-md-8\"> <h1 jhiTranslate=\"error.title\">Error Page!</h1> <div [hidden]=\"!errorMessage\"> <p class=\"alert alert-danger\" role=\"alert\" aria-live=\"polite\">{{errorMessage}}</p> </div> <p [hidden]=\"!error403\" class=\"alert alert-danger\" jhiTranslate=\"error.403\" role=\"alert\" aria-live=\"polite\">You are not authorized to access the page.</p> </div> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/app/layouts/error/error.component.html
// module id = 510
// module chunks = 0